<script>
  import Vue from 'vue'


  import VueBlockWithTopMenu from './BlockWithTopMenu'
  import VueCourseBlockWithTopMenu from './CourseBlockWithTopMenu'
  import VueSeriesList from './SeriesList'
  import VueCourseIntroduce from './CourseIntroduce'
  import VueCourseIntroduceBlock from './CourseIntroduceBlock'
  import VueVideoJS from './VideoJS'

  export default {
    VueBlockWithTopMenu,
    VueCourseBlockWithTopMenu,
    VueSeriesList,
    VueCourseIntroduce,
    VueCourseIntroduceBlock,
    VueVideoJS,
  }

</script>



// WEBPACK FOOTER //
// src/components/index.vue